import { useCallback, useSyncExternalStore } from 'react';

/**
 * 지금 화면이 미디어 쿼리에 맞는가 — 창 크기가 바뀌면 다시 그린다.
 *
 * CSS 로 두 벌을 그려 하나를 숨기는 대신 이걸 쓰는 경우: 같은 요소가 폭에 따라 **DOM 의 다른 자리**로
 * 가야 할 때다. 숨긴 사본도 테스트·검색엔진에는 그대로 두 벌로 읽힌다.
 *
 * 첫 렌더에서 바로 읽으므로 좁은 화면이 넓은 모양으로 한 번 번쩍이지 않는다.
 * matchMedia 가 없는 환경(jsdom)에서는 `fallback` 을 돌려준다.
 */
export function useMediaQuery(query: string, fallback = false): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') return () => {};
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    [query],
  );

  const getSnapshot = () =>
    typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback;

  return useSyncExternalStore(subscribe, getSnapshot);
}
